// extracted by mini-css-extract-plugin
export var sliderRange = "_kv-2";
export var sliderRoot = "_kv-0";
export var sliderThumb = "_kv-3";
export var sliderTrack = "_kv-1";